import { app } from '../../app';
import { PositionType } from '../../../lib/defs/types';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { IEffect } from './IEffect';
import { waitAFrame } from '../../../lib/util/waitAFrame';
import { FallingPetalAnimation } from '../../animations/FallingPetalAnimation';

// types
//-----------------------------------------------------------------------------
export type PetalFallingEffectOptions = {
  position: PositionType;
};

/*
    petal falling effect
*/
export class PetalFallingEffect implements IEffect {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _position: PositionType;

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, options: PetalFallingEffectOptions) {
    this._scene = scene;
    this._position = options.position;
  }

  public static assets(): string[] {
    return [];
  }

  // impl
  //-------------------------------------------------------------------------
  public async execute() {
    // wait a frame since we async the animation
    await waitAFrame();

    // animate
    this._animate();
  }

  // private: animation
  //-------------------------------------------------------------------------
  private async _animate() {
    // create  animation
    const animation = new FallingPetalAnimation();
    // spawn animation as overlay
    const entity = spawnOverlayEntity(
      this._scene,
      this._position,
      {},
      () => animation,
    );
    // run animation
    await animation.start();
    // despawn entity
    despawnOverlayEntity(this._scene, entity);
  }
}
